/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ExpiresInputs */

const en_expires = /** @type {(inputs: ExpiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires`)
};

const es_expires = /** @type {(inputs: ExpiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expira`)
};

/**
* | output |
* | --- |
* | "Expires" |
*
* @param {ExpiresInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const expires = /** @type {((inputs?: ExpiresInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ExpiresInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_expires(inputs)
	return es_expires(inputs)
});